"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledForm = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledForm = _styledComponents.default.form(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), _ref => {
  var _theme$components, _theme$components$for;

  let {
    theme
  } = _ref;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$for = _theme$components.form) === null || _theme$components$for === void 0 ? void 0 : _theme$components$for.form;
});

exports.StyledForm = StyledForm;